<ng-container *ngIf="change.changeType === changeType.Unchanged" data-qa-id="unchanged-value">
    {{ change.originalValue | nullDash }}<span *ngIf="change.originalValue"> year(s)</span>
</ng-container>
<ng-container *ngIf="change.changeType === changeType.Changed">
    <div class="value-panel">
        <span class="original-value" data-qa-id="original-year-value">{{ change.originalValue | nullDash }}</span>
        <span class="new-value" data-qa-id="new-year-value">{{ change.newValue | nullDash }}</span>
        <span> year(s)</span>
    </div>
</ng-container>


<ng-container *ngIf="noteChange.originalValue || noteChange.newValue">
    <ng-container *ngIf="noteChange && noteChange.changeType === changeType.Unchanged" data-qa-id="unchanged-note-value">
        <div class="note"> Note: {{ noteChange.originalValue | nullDash }}</div>
    </ng-container>
    <ng-container *ngIf="noteChange && noteChange.changeType === changeType.Changed">
        <div class="value-panel note">
            Note: <span class="original-value" data-qa-id="original-note-value">{{ noteChange.originalValue | nullDash }}</span>
            <span class="new-value" data-qa-id="new-note-value">{{ noteChange.newValue | nullDash }}</span>
        </div>
    </ng-container>
</ng-container>
